import classNames from "classnames";
import {ElementType} from "react";
import {FaChevronDown} from "react-icons/fa6";

import {Button} from "@/components/button/Button.tsx";
import {ButtonProps} from "@/components/button/Button.types.ts";
import {Dropdown} from "@/components/dropdown/Dropdown.tsx";
import {DropdownButtonGroupProps} from "@/components/dropdownButtonGroup/DropdownButtonGroup.types.ts";
import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./DropdownButtonGroup.module.scss";

export const DropdownButtonGroup = <T extends ElementType = "button">({
  className,
  title,
  children,
  icon,
  size = "large",
  variant,
  toggleClassName,
  ...rest
}: DropdownButtonGroupProps<T>) => {
  return (
    <Dropdown className={classNames("btn-group", className)}>
      <Button className={styles.dropdownStart} size={size} variant={variant} {...(rest as ButtonProps<T>)}>
        {icon && <Icon icon={icon} />}
        {title}
      </Button>
      <Dropdown.Toggle
        className={classNames(styles.dropdownEnd, styles[size], toggleClassName)}
        size={size}
        variant={variant}
      >
        <Icon icon={FaChevronDown} />
      </Dropdown.Toggle>
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  );
};
